import React from 'react'
import * as bsIcons from 'react-icons/bs'
import * as io5Icons from 'react-icons/io5'
import * as riIcons from 'react-icons/ri'
import * as faIcons from 'react-icons/fa'

import { getSmartSize } from '../../utils/helpers/styles'
import { useColor } from '../theme/_hooks/colors'
import ConditionalLink from '../actions/ConditionalLink'

const Icon = ({ name, color, size, onClick, path }) => {
  const colorValue = useColor(color, 'primary')
  const sizeValue = getSmartSize(size, {}, 1)
  const style = {
    fontSize: sizeValue,
    height: sizeValue
  }

  let Icon = bsIcons[name]
  // if (!Icon) Icon = hiIcons[name]
  // if (!Icon) Icon = ioIcons[name]
  if (!Icon) Icon = io5Icons[name]
  if (!Icon) Icon = riIcons[name]
  if (!Icon) Icon = faIcons[name]
  if (!Icon) return false

  return (
    <ConditionalLink onClick={onClick} path={path} block>
      <Icon style={style} color={colorValue} />
    </ConditionalLink>
  )
}

export default Icon
